import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LaborDetailDialogComponent } from '../labor-detail-dialog/labor-detail-dialog.component';
import { LaborService } from "../labor.service";
import { Router } from '@angular/router';
@Component({
  selector: 'app-unconfirmed-labor-component',
  templateUrl: './unconfirmed-labor.component.html',
  styleUrls: ['./unconfirmed-labor.component.css']
})
export class UnconfirmedLaborComponent implements OnInit {

  laborList: any[] = [];
  source : any[] = [];
  isLoading: boolean = false;
  selectedDateOption: string = '';
  dateOptions: string[] = [];

  constructor(
    private laborService: LaborService,
    private dialog: MatDialog,
    private router: Router
  ) {
    var isLogin = localStorage.getItem('isLogin');
    if (isLogin != 'true' || isLogin == null) {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() {
    this.loadUnconfirmedLabor();
  }

  loadUnconfirmedLabor() {
    this.isLoading = true;
    this.selectedDateOption = "";
    this.laborService.getUnconfirmed()
      .subscribe(
        (data: any[]) => {
          // Extract unique insertedDate values for dropdown options
          this.dateOptions = Array.from(new Set(data.map(labor => labor.insertedDate)));
          this.dateOptions.unshift("All");
          this.source = data;
          this.laborList = data.sort((a, b) => {
            // Split date strings into components (month, day, year)
            const aDateParts = a.insertedDate.split('/');
            const bDateParts = b.insertedDate.split('/');
            // Construct Date objects for comparison (year, month - 1, day)
            const aDate = new Date(+aDateParts[2], +aDateParts[0] - 1, +aDateParts[1]);
            const bDate = new Date(+bDateParts[2], +bDateParts[0] - 1, +bDateParts[1]);
            // Compare Date objects
            return bDate.getTime() - aDate.getTime();
          });
          this.isLoading = false;
        },
        error => {
          console.error('Error fetching data:', error);
          this.isLoading = false;
        }
      );
  }

  filterLaborByDate(): void {    
    if (!this.selectedDateOption || this.selectedDateOption == "All") {
      // If no date option is selected, reset the labor list to the original list
      this.loadUnconfirmedLabor();
      return;
    }

    // Filter labor list based on selected date option
    this.laborList = this.source.filter(labor => labor.insertedDate === this.selectedDateOption);
  }

  viewLaborDetails(labor: any) {
    const dialogRef = this.dialog.open(LaborDetailDialogComponent, {
      width: '50%',
      data: labor
    });

    dialogRef.afterClosed().subscribe((reloadPage: boolean) => {
      if (reloadPage) {
        // Reload the page
        window.location.reload();
      }
    });
  }
}